import SuperAdminDashboard from "@/views/SuperAdminDashboard.vue"

const TITLE_PREFIX = "adtron®"

export default [
  {
    path: "/system/dashboard",
    name: "superadmin-dashboard",
    component: SuperAdminDashboard,
    meta: {
      title: `${TITLE_PREFIX} - SuperAdmin Dashboard`
    }
  }
]
